<template>
    <div>
        <kgr-dropdown
            display="number"
            :label="label"
            :value="value"
            :options="filteredClubCostCenters"
            :loading="loading"
            :inline="inline"
            :disabled="departmentId === null"
            @input="onInput($event)"
        />
    </div>
</template>

<script>
import ClubCostCenter from '../../../../js/dto/ClubCostCenter.js';
import ClubCostCenterRepository from '../../../../js/repository/ClubCostCenterRepository.js'
import Dropdown from './Dropdown.vue';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubCostCenter,
            required: false,
            default: null,
        },
        departmentId: {
            type: Number,
            required: false,
            default: null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubCostCenters: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('Kostenstelle');
        },
        filteredClubCostCenters() {
            if (this.departmentId === null) {
                return [];
            }
            return this.clubCostCenters.filter(clubCostCenter => clubCostCenter.departmentId === this.departmentId);
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.loading = true;
            ClubCostCenterRepository.findByClubId(this.clubId, true)
                .then(response => this.clubCostCenters = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },

        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
}
</script>
